import { gql, TypedDocumentNode } from '@apollo/client';
import { PAYMENT_METHOD_FRAGMENT, PaymentMethod } from '../usePaymentMethodsQuery';
import { Psd2Params } from '../usePsd2';

export type CreatePaymentMethodMutationInput = {
  data: {
    type: 'payments';
    attributes: Psd2Params & {
      encrypted_data: string;
      billing_address: {
        country_name: string;
        extended_address: string | null;
        id: string | null;
        locality: string;
        postal_code: string;
        region: string;
        street_address: string;
      };
    };
  };
};

export type CreatePaymentMethodMutationVariables = {
  input: CreatePaymentMethodMutationInput;
};

export type CreatePaymentMethodMutation = {
  createPaymentMethod: {
    __typename: 'RestCreatePaymentMethod';
    data: PaymentMethod;
  };
};

export const CREATE_PAYMENT_METHOD_MUTATION: TypedDocumentNode<
  CreatePaymentMethodMutation,
  CreatePaymentMethodMutationVariables
> = gql`
  mutation CreatePaymentMethodMutation($input: CreatePaymentMethodMutationInput!) {
    createPaymentMethod(input: $input)
      @rest(
        type: "RestCreatePaymentMethod"
        endpoint: "cart"
        path: "/v3.5/payments"
        method: "POST"
      ) {
      data @type(name: "RestPaymentMethod") {
        ...PaymentMethodFragment
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
